import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import frCommon from './locales/fr/common.json';
import deCommon from './locales/de/common.json';
import enTerms from './locales/en/terms.json';
import deTerms from './locales/de/terms.json';
import enHelp from './locales/en/help.json';
import deHelp from './locales/de/help.json';

// Create a placeholder for Italian translations
const itCommon = { ...enCommon };

const resources = {
  en: {
    common: enCommon,
    terms: enTerms,
    help: enHelp
  },
  es: {
    common: esCommon
  },
  fr: {
    common: frCommon
  },
  de: {
    common: deCommon,
    terms: deTerms,
    help: deHelp
  },
  it: {
    common: itCommon
  },
  gb: {
    common: enCommon,
    terms: enTerms,
    help: enHelp
  }
};

// Check localStorage for saved language preference
const savedLanguage = localStorage.getItem('language');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage || undefined, // Use saved language if available
    fallbackLng: 'de',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'localStorage'],
      caches: ['localStorage']
    }
  });

export default i18n;